import { Component, Vue } from 'vue-facing-decorator';
import { ElMessage, ElMessageBox } from 'element-plus';
import { EditPen, Delete, List, PictureFilled, LocationFilled, CirclePlusFilled, UserFilled } from '@element-plus/icons-vue';
import Header from '@/components/Header/Header.vue';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';
import Navigation from '@/components/Navigation/Navigation.vue';
import NavigationIndex from "@/models/EnumNavigationIndex";
import AuthService from '@/services/AuthService';
import ApiService from '@/services/ApiService';

interface TransferItem
{
    key : number;
    label : string;
    disabled : boolean;
}

@Component(
{
    components:
    {
        Header,
        Breadcrumbs,
        Navigation,
		EditPen,
		Delete,
		List,
		PictureFilled,
		LocationFilled,
		CirclePlusFilled,
        UserFilled
    },
    enums:
    {
        NavigationIndex
    }
})

export default class CustomerEdit extends Vue 
{
    private activeName: string = "0";
    private customerId : string = '';
    private customerName : string = '';
    private hasPermission: boolean[] = [] as boolean[];
    private customerModel : CustomerModel | undefined = {} as CustomerModel;
    private contactTypeModelList : ContactTypeModel[] = [] as ContactTypeModel[];
    private locationModelList : LocationModel[] = [] as LocationModel[];
    private tokenlistModelList : TokenListView[] = [] as TokenListView[];
    private tokenModelList : TokenView[] | undefined = [] as TokenView[];
    private locationToDelete : LocationModel | undefined;
    private contactToDelete : ContactModel | undefined;
    private ticketListToDelete : TokenListModel | undefined;
    private loading : boolean = true;
    private loadingTokens : boolean = true;
    private formCustomerValid : boolean = true;
    private formContactValid : boolean = false;
    private formLocationValid : boolean = false;
    private newLocationModel : LocationModel = {} as LocationModel;
    private newContactModel : ContactModel = {} as ContactModel;
    private questionnaireModelList : QuestionnaireModel[] = [] as QuestionnaireModel[];
    private contactModelList : ContactModel[] = [] as ContactModel[];
    private bannerURL : string | undefined = '';
    private selectedAttributes : number[] = [] as number[];
    private availableAttributes : TransferItem[] = [] as TransferItem[];
    private tokenPage : number = 0;
    private windowWidth : number = window.innerWidth;
    private windowHeight : number = window.innerHeight;
    private allowedPrefixChars : string = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    private rules =
    {
        name:
        [
            {
                required: true,
                message: "Bitte geben Sie eine Bezeichnung ein.",
                trigger: "blur"
            }
        ],
        email:
        [
            {
                required: true,
                message: "Bitte geben Sie eine E-Mail ein.",
                trigger: "blur"
            }
        ],
        street:
        [
            {
                required: true,
                message: "Bitte geben Sie der Strasse des Mandanten ein.",
                trigger: "blur"
            }
        ],
        zipcode:
        [
            {
                required: true,
                message: "Bitte geben Sie die Postleitzahl des Mandanten ein.",
                trigger: "blur"
            }
        ],
        city:
        [
            {
                required: true,
                message: "Bitte geben Sie der Ort des Mandanten ein.",
                trigger: "blur"
            }
        ],
        valid_from:
        [
            {
                required: true,
                message: "Bitte geben Sie das Anfangsdatum der Gültigkeit ein.",
                trigger: "blur"
            }
        ],
        valid_until:
        [
            {
                required: true,
                message: "Bitte geben Sie das Endedatum der Gültigkeit ein.",
                trigger: "blur"
            }
        ]
    };

    private rulesContact1 =
    {
        name:
        [
            {
                required: true,
                message: "Bitte geben Sie eine Bezeichnung für diesen Ansprechpartner ein.",
                trigger: "blur"
            }
        ],
        email:
        [
            {
                required: true,
                message: "Bitte geben Sie eine gültige E-Mail für diesen Ansprechpartner ein.",
                trigger: "blur"
            }
        ],
    };

    private rulesContact2 =
    {
        name:
        [
            {
                required: true,
                message: "Bitte geben Sie eine Bezeichnung für diesen Ansprechpartner ein.",
                trigger: "blur"
            }
        ],
        department:
        [
            {
                required: true,
                message: "Bitte geben Sie eine zuständige Abteilung für diesen Ansprechpartner an.",
                trigger: "blur"
            }
        ],
        lastname:
        [
            {
                required: true,
                message: "Bitte geben Sie den Nachname des Ansprechpartners ein.",
                trigger: "blur"
            }
        ],
        email:
        [
            {
                required: true,
                message: "Bitte geben Sie eine gültige E-Mail für diesen Ansprechpartner ein.",
                trigger: "blur"
            }
        ],
        phone:
        [
            {
                required: true,
                message: "Bitte geben Sie eine Telefonnummer für diesen Ansprechpartner ein.",
                trigger: "blur"
            }
        ]
    };

    private rulesContact3 =
    {
        name:
        [
            {
                required: true,
                message: "Bitte geben Sie eine Bezeichnung für diesen Ansprechpartner ein.",
                trigger: "blur"
            }
        ],
        department:
        [
            {
                required: true,
                message: "Bitte geben Sie eine zuständige Abteilung für diesen Ansprechpartner an.",
                trigger: "blur"
            }
        ],
        firstname:
        [
            {
                required: true,
                message: "Bitte geben Sie den Vornamen des Ansprechpartners ein.",
                trigger: "blur"
            }
        ],
        lastname:
        [
            {
                required: true,
                message: "Bitte geben Sie den Nachnamen des Ansprechpartners ein.",
                trigger: "blur"
            }
        ],
        email:
        [
            {
                required: true,
                message: "Bitte geben Sie eine gültige E-Mail für diesen Ansprechpartner ein.",
                trigger: "blur"
            }
        ],
        phone:
        [
            {
                required: true,
                message: "Bitte geben Sie eine Telefonnummer für diesen Ansprechpartner ein.",
                trigger: "blur"
            }
        ]
    };

    public async mounted()
    {
        // get permissions
        await AuthService.getPermissions();
        this.hasPermission['CUST_SELECT'] = AuthService.hasPermission("CUST_SELECT");
        this.hasPermission['CUST_INSERT'] = AuthService.hasPermission("CUST_INSERT");
        this.hasPermission['CUST_UPDATE'] = AuthService.hasPermission("CUST_UPDATE");
        this.hasPermission['CUST_DELETE'] = AuthService.hasPermission("CUST_DELETE");

        // get customer id from get request
        this.customerId = this.$route.params.customerid as string;

        // load customer from db
        this.customerModel = await ApiService.getCustomer(this.customerId);

        if (!this.customerModel) 
        {
            this.$router.push('/customer');
            return;
        }
        else
        {
            this.customerName =  this.customerModel.name;
            if (this.customerModel.banner_size > 0)
            {
                //await this.loadBanner();
            }
        }

        if (this.hasPermission['CUST_SELECT'])
        {
            // load contact types
            this.loadContactTypeList();

            // load contacts of this customer
            this.loadContactList();

            // load locations of this customer
            this.loadLocationList();

            // load available questionnaires
            this.loadQuestionnaireList();

            this.formCustomerValid = this.validateCustomerForm();
            this.formLocationValid = this.validateLocationForm();
            this.formContactValid = this.validateContactForm();
        }
        
        window.addEventListener('resize', this.onWindowResize);

        this.loading = false;
    }

    private beforeUnmount()
    {
        window.removeEventListener('resize', this.onWindowResize);
    }

	private onWindowResize(e : any)
    {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    }

    private async loadQuestionnaireList()
    {
        this.loading = true;
        this.questionnaireModelList = await ApiService.getAllQuestionnaireForCustomer(this.customerId) as QuestionnaireModel[];
        this.loading = false;
    }

    private async loadContactTypeList()
    {
        this.loading = true;
        this.contactTypeModelList = await ApiService.getAllContactTypes() as ContactTypeModel[];
        this.newContactModel.contacttypeid = 1;
        this.loading = false;
    }

    private async loadContactList()
    {
        this.loading = true;
        this.contactModelList = await ApiService.getAllContactsByCustomerId(this.customerId) as ContactModel[];
        this.loading = false;
    }

    private async loadLocationList()
    {
        this.loading = true;
        this.locationModelList = await ApiService.getAllLocationsByCustomerId(this.customerId) as LocationModel[];
        this.loading = false;
    }

    private async saveCustomer(customer : CustomerModel)
    {
        let ok : any = await ApiService.updateCustomer(customer);

        if (ok)
        {
			ElMessage({message: "Änderungen wurden übernommen.", type: 'success'});
        }
        else
        {
            // or show error message
			ElMessage({message: "Änderungen konnten nicht gespeichert werden.",	type: 'error'});
        }
    }

    private async createLocation()
    {
        // send new department model via request to API and await
        this.newLocationModel.customerid = this.customerModel!.customerid;
        let location = await ApiService.createLocation(this.newLocationModel);

        // check if successful
        if (location)
        {
			ElMessage({message: "Neuer Standort wurde erfolgreich erstellt.", type: 'success'});
            this.activeName = "4";
            this.newLocationModel = {} as LocationModel;
            this.formLocationValid = false;
            await this.loadLocationList();
        }
        else
        {
            // or show error message
			ElMessage({message: "Beim Erstellen des neuen Standorts ist ein Fehler aufgetreten.",	type: 'error'});
        }
    }

    private async updateLocation(location : LocationModel)
    {
        let ok : any = await ApiService.updateLocation(location);

        if (ok)
        {
			ElMessage({message: "Änderungen wurden übernommen.", type: 'success'});
        }
        else
        {
            // or show error message
			ElMessage({message: "Änderungen konnten nicht gespeichert werden.",	type: 'error'});
        }
    }

    private async deleteLocation(location : LocationModel)
    {
        let ok = await ApiService.deleteLocation(location);

        if (ok)
        {
			ElMessage({message: "Standort wurde gelöscht.",	type: 'success'});
            await this.loadLocationList();
        }
        else
        {
            // or show error message
			ElMessage({message: "Standort konnte nicht gelöscht werden.", type: 'error'});
        }
    }

    private async deleteContact(contact : ContactModel)
    {
        let ok = await ApiService.deleteContact(contact);

        if (ok)
        {
			ElMessage({message: "Ansprechpartner wurde gelöscht.", type: 'success'});
            await this.loadContactList();
        }
        else
        {
            // or show error message
			ElMessage({message: "Ansprechpartner konnte nicht gelöscht werden.", type: 'error'});
        }
    }

    private async createContact()
    {
        // send new contact model via request to API and await
        this.newContactModel.customerid = this.customerModel.customerid;
        let contact = await ApiService.createContact(this.newContactModel);

        // check if successful
        if (contact)
        {
			ElMessage({message: "Neuer Ansprechpartner wurde erfolgreich erstellt.", type: 'success'});
            this.activeName = "2";
            this.newContactModel = {} as ContactModel;
            this.newContactModel.contacttypeid = 1;
            this.formContactValid = false;
            await this.loadContactList();
        }
        else
        {
            // or show error message
			ElMessage({message: "Beim Erstellen des neuen Ansprechpartners ist ein Fehler aufgetreten.",	type: 'error'});
        }
    }

    private validateEmail(email : string)
    {
        let re: RegExp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        return re.test(email);
    }

    private validateCustomerForm() : boolean
    {
        if (!this.customerModel || this.customerModel!.name.length <= 0) return false;
        if (!this.customerModel.email || this.customerModel.email.length <= 0) return false;
        if (!this.validateEmail(this.customerModel.email)) return false;
        if (!this.customerModel.street || this.customerModel.street.length <= 0) return false;
        if (!this.customerModel.zipcode || this.customerModel.zipcode.length <= 0) return false;
        if (!this.customerModel.city || this.customerModel.city.length <= 0) return false;
        
        if (!this.customerModel.tokenprefix || this.customerModel.tokenprefix.length < 2) return false;
        for (let c of this.customerModel.tokenprefix)
        {
            if (this.allowedPrefixChars.indexOf(c) < 0) return false;
        }

        return true;
    }

    private validateLocationForm() : boolean
    {
        if (!this.newLocationModel.name || this.newLocationModel.name.length <= 0) return false;

        return true;
    }

    private validateContactForm() : boolean
    {
        if (!this.newContactModel.name || this.newContactModel.name.length <= 0) return false;
        if (!this.newContactModel.email || this.newContactModel.email.length <= 0) return false;
        if (!this.validateEmail(this.newContactModel.email)) return false;

        if (this.newContactModel.contacttypeid == 2)
        {
            if (!this.newContactModel.department || this.newContactModel.department.length <= 0) return false;
            if (!this.newContactModel.lastname || this.newContactModel.lastname.length <= 0) return false;
            if (!this.newContactModel.phone || this.newContactModel.phone.length <= 0) return false;
        }

        if (this.newContactModel.contacttypeid == 3)
        {
            if (!this.newContactModel.department || this.newContactModel.department.length <= 0) return false;
            if (!this.newContactModel.firstname || this.newContactModel.firstname.length <= 0) return false;
            if (!this.newContactModel.lastname || this.newContactModel.lastname.length <= 0) return false;
            if (!this.newContactModel.phone || this.newContactModel.phone.length <= 0) return false;
        }

        return true;
    }

	/*
    private async loadBanner()
    {
        if (this.customerModel)
        {
            this.bannerURL = `${ApiService.API_BASE_PATH}/customer/${this.customerModel.customerid.toString()}/banner/image`;
        }

        this.loading = false;
    }
	*/
    private async deleteBanner()
    {
        this.bannerURL = '';

        if (this.customerModel)
        {
            await ApiService.removeCustomerBanner(this.customerModel.customerid.toString());
        }
    }

    private onLocationInput()
    {
        this.formLocationValid = this.validateLocationForm();
    }

    private onContactInput()
    {
        this.formContactValid = this.validateContactForm();
    }

    private onCustomerInput()
    {
        if (this.customerModel.tokenprefix)
        {
            this.customerModel.tokenprefix = this.customerModel.tokenprefix.toUpperCase();
        }
        this.formCustomerValid = this.validateCustomerForm();
    }

    private onCustomerSaveClick()
    {
        if (this.customerModel)
        {
            this.saveCustomer(this.customerModel);
        }
    }

    private onLocationDeleteConfirm(action : string)
    {
        if (this.locationToDelete && action == 'confirm')
        {
            this.deleteLocation(this.locationToDelete);
        }
    }

    private onContactDeleteConfirm(action : string)
    {
        if (this.contactToDelete && action == 'confirm')
        {
            this.deleteContact(this.contactToDelete);
        }
    }

    private onBannerDeleteConfirm(action : string)
    {
        if (action == 'confirm')
        {
            this.deleteBanner();
        }
    }

    private onNewLocationClick()
    {
        this.createLocation();
    }

    private onNewContactClick()
    {
        this.createContact();
    }

    private onLocationSaveClick(location : LocationModel)
    {
        this.updateLocation(location);
    }

    private onLocationEditClick(location : LocationModel)
    {
        this.$router.push(`/customer/${this.customerId}/location/${location.locationid}`);
    }

    private onLocationDeleteClick(location : LocationModel)
    {
        this.locationToDelete = location;

        ElMessageBox.confirm(`Soll der Standort "${location.name}" wirklich gelöscht werden?`, 'Warning', 
        {
            type: 'warning',
            title: '',
            callback: this.onLocationDeleteConfirm,
            confirmButtonText: 'Löschen',
            cancelButtonText: 'Abbrechen'
        });
    }

    private onContactEditClick(contact : ContactModel)
    {
        this.$router.push(`/customer/${this.customerId}/contact/${contact.contactid}`);
    }

    private onContactDeleteClick(contact : ContactModel)
    {
        this.contactToDelete = contact;

        ElMessageBox.confirm(`Soll der Ansprechpartner "${contact.name}" wirklich gelöscht werden?`, 'Warning', 
        {
            type: 'warning',
            title: '',
            callback: this.onContactDeleteConfirm,
            confirmButtonText: 'Löschen',
            cancelButtonText: 'Abbrechen'
        });
    }

    private onBannerDeleteClick()
    {
        ElMessageBox.confirm(`Soll das Banner wirklich entfernt werden?`, 'Warning', 
        {
            type: 'warning',
            title: '',
            callback: this.onBannerDeleteConfirm,
            confirmButtonText: 'Löschen',
            cancelButtonText: 'Abbrechen'
        });
    }

    private async readImage(file : any)
    {
        let data : Blob = file.raw;

        if (this.customerModel)
        {
            this.loading = true;
            await ApiService.setCustomerBanner(this.customerModel.customerid.toString(), file.raw);
            this.bannerURL = URL.createObjectURL(data);
            this.loading = false;
        }
    }

    private onImageSelect(file : any, fileList : FileList)
    {
        this.readImage(file);
    }

    private beforeImageUpload(file : File) 
    {
        let isJPG : boolean = (file.type === 'image/jpeg');
        let isPNG : boolean = (file.type === 'image/png');
        
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG && !isPNG) 
        {
			ElMessage({message: "Es können ausschließlich JPG oder PNG Dateien verwendet werden.",	type: 'error'});
        }

        if (!isLt2M) 
        {
			ElMessage({message: "Die Bilddatei darf nicht größer als 2 MB sein.",	type: 'error'});
        }

        return isJPG && isLt2M;
    }

    private onAttributeChange(x : any)
    {
        this.storeAttributeSelection();
    }
}
